module.exports = __webpack_public_path__ + "img/konfigurator-tooltip-spiegel-06.48b98cea.jpg";